import React from "react";
import {
    Card,
    CardContent,
    Typography,
    FormControl,
    FormLabel,
    Select,
    Option,
    Box,
    Input,
} from "@mui/joy";
import { CreditCard } from "lucide-react";
import { SettingField, ESTIMATING_CONFIG } from "./EstimatingCommon";

interface PaymentConfigProps {
    values: Record<string, any>;
    onChange: (key: string, value: any) => void;
}

export default function PaymentConfig({ values, onChange }: PaymentConfigProps) {
    return (
        <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
            <CardContent>
                <Typography level="title-sm" mb={2} startDecorator={<CreditCard size={18} />}>
                    Payment Configuration
                </Typography>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                    <SettingField label="Payment Mechanism">
                        <Select
                            size="sm"
                            value={values.EST_PAYMENT_TYPE}
                            onChange={(_, val) => onChange("EST_PAYMENT_TYPE", val)}
                            sx={{ minWidth: 140 }}
                        >
                            {ESTIMATING_CONFIG.OPTIONS.PAYMENT_TYPES.map((opt) => (
                                <Option key={opt.value} value={opt.value}>{opt.label}</Option>
                            ))}
                        </Select>
                    </SettingField>

                    {values.EST_PAYMENT_TYPE === "insurance" && (
                        <>
                            <SettingField label="Deductible">
                                <Input
                                    size="sm"
                                    startDecorator="$"
                                    placeholder="1000.00"
                                    type="number"
                                    value={values.EST_DEDUCTIBLE}
                                    onChange={(e) => onChange("EST_DEDUCTIBLE", e.target.value)}
                                    sx={{ width: 100 }}
                                />
                            </SettingField>
                            <SettingField label="O&P %">
                                <Input
                                    size="sm"
                                    endDecorator="%"
                                    type="number"
                                    value={values.EST_OP_PERCENT}
                                    onChange={(e) => onChange("EST_OP_PERCENT", e.target.value)}
                                    sx={{ width: 100 }}
                                />
                            </SettingField>
                        </>
                    )}

                    {(values.EST_PAYMENT_TYPE === "credit" || values.EST_PAYMENT_TYPE === "debit") && (
                        <SettingField label="Card processing fee">
                            <Input
                                size="sm"
                                endDecorator="%"
                                value={values.EST_CC_FEE_PERCENT}
                                type="number"
                                onChange={(e) => onChange("EST_CC_FEE_PERCENT", e.target.value)}
                                sx={{ width: 100 }}
                            />
                        </SettingField>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
}
